import { SVGProps } from 'react';

const SvgTimer = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8.652 2a1 1 0 0 1 1-1h5.217a1 1 0 0 1 0 2h-.304v2.37a8.977 8.977 0 0 1 3.053 1.598l.674-.675a1 1 0 0 1 1.632-1.088l.87.87a1 1 0 0 1-1.088 1.632l-.674.675A9 9 0 1 1 3 14a9.004 9.004 0 0 1 6.956-8.767V3h-.304a1 1 0 0 1-1-1Zm3.304 1v2a9.064 9.064 0 0 1 .609.017V3h-.609ZM12 7a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-3.707 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgTimer;
